import React from "react";
import styles from "./index.module.scss";

const PageType = {
  PT_HOME: 0,
  PT_PAY: 1,
  PT_ABOUT: 2,
  PT_CONTACT: 3,
  PT_QRCODE: 4,
};
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageIndex: PageType.PT_HOME,
      showQrcode: false,
    };
  }
  renderHome() {
    return (
      <>
        <div className={styles.title}>鳄梨科技重新定义</div>
        <div className={styles.subTitle}>大规模用工招聘面试流程</div>
        <div className={styles.desc}>
          帮助企业以更低成本更快找到更合适的员工
        </div>
      </>
    );
  }
  showQrcode() {
    this.setState({
      showQrcode: true,
    });
  }
  closeQrcode() {
    this.setState({
      showQrcode: false,
    });
  }
  renderPay() {
    const { showQrcode } = this.state;
    return (
      <>
        <div className={styles.title}>付费资讯</div>
        <div className={styles.topic}>
          <div className={styles.img}>
            <img
              className={styles.img}
              src="http://icp.erbg.ren/static_asset/p1.png"
            />
          </div>

          <div className={styles.topicDesc}>
            在2020世界人工智能大会（WAIC）行业趋势主题论坛上，上海依图网络科技有限公司联合创始人、首席执行官朱珑博士以“打造清晰
            ‘可视’AI新时代”为题发表演讲。
            朱珑表示，未来十年，机器的性能仍可能会再以数十倍的速度提升，低阶感知智能将向高阶决策智能跃迁...
            <div
              onClick={(event) => {
                this.setState({
                  pageIndex: PageType.PT_QRCODE,
                });
              }}
              className={styles.clickPay}
            >
              付费阅读：20元/次
            </div>
          </div>
        </div>
        <div className={styles.topic}>
          <div className={styles.img}>
            <img
              className={styles.img}
              src="http://icp.erbg.ren/static_asset/p2.png"
            />
          </div>

          <div className={styles.topicDesc}>
            据新浪科技报道，网易公司首席执行官丁磊谈到他对人工智能的看法，他表示，“人工智能这个名字不新鲜，我读大学的时候就有相关的称呼。”丁磊说，网易用人工智能比较多的就是教育领域，以及用人工智能帮助作曲。网易还在欧洲投资了一家利用人工智能作曲的初创公司...
            <div
              onClick={(event) => {
                this.setState({
                  pageIndex: PageType.PT_QRCODE,
                });
              }}
              className={styles.clickPay}
            >
              付费阅读：20元/次
            </div>
          </div>
        </div>
      </>
    );
  }
  renderQrcode() {
    return (
      <>
        <div className={styles.title}>支付</div>
        {
          <img
            className={styles.qrcode}
            src="http://icp.erbg.ren/static_asset/wechaticp.png"
          />
        }
      </>
    );
  }

  renderAbout() {
    return (
      <>
        <div className={styles.title}>关于我们</div>
        <div className={styles.desc}>
          北京鳄梨科技有限公司于2019年成立于北京，致力于人工智能服务方向，团队主要来自于硅谷和BAT。
        </div>
      </>
    );
  }

  rendeCrontactUs() {
    return (
      <>
        <div className={styles.title}>联系我们</div>
        <div className={styles.desc}>北京鳄梨科技有限公司</div>
        <div className={styles.desc}>地址：北京市朝阳区霄云中心A座1603室</div>
        <div className={styles.desc}>合作邮箱：kefu@elihr.cn</div>
      </>
    );
  }
  renderBody() {
    const { pageIndex } = this.state;
    switch (pageIndex) {
      case PageType.PT_HOME:
        return this.renderHome();
      case PageType.PT_PAY:
        return this.renderPay();
      case PageType.PT_ABOUT:
        return this.renderAbout();
      case PageType.PT_CONTACT:
        return this.rendeCrontactUs();
      case PageType.PT_QRCODE:
        return this.renderQrcode();
      default:
        return this.renderHome();
    }
  }
  render() {
    const MenuList = ["首页", "付费资讯", "关于我们", "联系我们"];
    const { pageIndex } = this.state;
    return (
      <div
        className={styles.content}
        onClick={() => {
          this.closeQrcode();
        }}
      >
        <div className={styles.head}>
          <div className={styles.content}>
            <div className={styles.logo}>鳄梨科技</div>
            <div className={styles.menu}>
              {MenuList.map((item, index) => {
                return (
                  <div
                    className={
                      pageIndex === index
                        ? styles.menuItemSelected
                        : styles.menuItem
                    }
                    onClick={() => {
                      this.setState({ pageIndex: index });
                    }}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.content}>{this.renderBody()}</div>
        </div>
        <div className={styles.footer}>
          <div className={styles.content}>
            <div className={styles.copyright}>
              鳄梨科技版权所有 copyright ©️ elihr.cn | 京ICP备19043412号-2
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
